import { Descriptions, RadioChangeEvent } from "antd";
import '../../styles/class/feedback/writingImprove.css';
import _ from "lodash";
import moment from "moment";
import QueryString from "qs";
import React, { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ReactPlayer from "react-player";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { getEvaluationItems, getWritingEvaluationItems } from "../../api/mypage.api";
import { getSavedFeedback, getStudentFile, getStudentFiles, getStudentWriting, postWritingSpeakingFeedback } from "../../api/tutor.api";
import Button from "../../components/Button";
import EvaluationItem from "../../components/tutor/assess/EvaluationItem";
import useAxios from "../../hooks/useAxios";
import useNotification from "../../hooks/useNotification";
import { IGetEvaluationItems } from "../../models/mypage.model";
import { IGetSavedFeedback } from "../../models/tutor.model";
import useLoader from "../../hooks/useLoader";
import { Helmet } from 'react-helmet';
import Loader from '../../components/Loader';
import CommentEditor from '../../components/tutor/assess/CommentEditor';
import { COMPLETE_TYPE, FEEDBACK_TYPE } from './assess';
import {
  useGetCorrectionResultCountQuery,
  useGetReviewedContentQuery,
  useLazyGetProofreadingQuery,
} from '../../api/edutem/edutem.api';
import OverallWordCheckModal from '../../components/tutor/assess/modals/OverallWordCheckModal';
import { useGetSaveCorrectTextQuery } from '../../api/united-associates/united-associates.api';
import ConfirmModal from '../../components/modals/ConfirmModal';

const TutorAssessWs = () => {
  const location = useLocation();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
  const rubricNo = Number(query.rubricNo);
  const resultCode = Number(query.resultCode);
  const learningTlStructureNo = Number(query.learningTlStructureNo);
  const seq = Number(query.seq);
  const activityCode = Number(query.activityCode);
  const curriculumName = String(query.curriculumName);
  const studentKorName = String(query.studentKorName);
  const studentEngName = String(query.studentEngName);
  const regDate = String(query.regDate);
  const displayName = String(query.displayName);
  const activityName = String(query.activityName);
  const activityType = String(query.activityType);
  const feedbackTypeCode = String(query.feedbackTypeCode);
  const isReadOnly = Boolean(query.isReadOnly);
  const { t, i18n } = useTranslation();

  const { infoNotification, successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetEvaluationItems>();
  const { data: res2, isLoading: isLoading2, error: error2, execute: execute2 } = useAxios<any>();
  const { data: res3, isLoading: isLoading3, error: error3, execute: execute3 } = useAxios<IGetEvaluationItems>();
  const { data: res4, isLoading: isLoading4, error: error4, execute: execute4 } = useAxios<any>();
  const { data: res5, isLoading: isLoading5, error: error5, execute: execute5 } = useAxios<IGetSavedFeedback>();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios();
  const { data: submitRes2, isLoading: submitIsLoading2, error: submitError2, execute: submitExecute2 } = useAxios();
  const [proofreadAll, { currentData: proofreadAllData, isLoading: isProofreadAllLoading, isFetching: isProofreadAllFetching, error: proofreadAllError }] = useLazyGetProofreadingQuery();
  const { data: getReviewedResponse, isLoading: isReviewedLoading } = useGetReviewedContentQuery(res4?.data.reviewedCode, { skip: !res4?.data.reviewedCode })
  const { data: getAdvisorSaveTexts, isLoading: isAdvisorTextLoading } = useGetSaveCorrectTextQuery(res4?.data?.studentAnswer?.map((item:any) => {
    return {...item, quizResultCode: res4?.data?.quizResultCode }
  }), { skip: !res4?.data });
  const { data: getCorrectionCountResponse } = useGetCorrectionResultCountQuery({
    rubricNo,
    resultCode,
    learningTlStructureNo,
    seq,
    activityCode,
    isRewrite: true
  }, { skip: !resultCode || !learningTlStructureNo });


  useLoader(
    isLoading || isLoading2 || isLoading3 || isLoading4 || isLoading5 || submitIsLoading || submitIsLoading2,
    [error, error2, error3, error4, error5, submitError, submitError2],
  );

  const [speakingData, setSpeakingData] = useState<any[]>([]);
  const [writingData, setWritingData] = useState<any[]>([]);
  const [speakingAnswers, setSpeakingAnswers] = useState<string[]>([]);
  const [writingAnswers, setWritingAnswers] = useState<string[]>([]);
  const [step, setStep] = useState(1);
  const [showSttVisible, setShowSttVisible] = useState(false);
  const [recogSentence, setRecogSentence] = useState('');
  const [confirmSubmitVisible, setConfirmSubmitVisible] = useState(false);
  const [_sentencesAll, setSentencesAll] = useState<any>([]);
  const [originalWordCount, setOriginalWordCount] = useState<number>(0);
  const [errorWordCount, setErrorWordCount] = useState<number>(0);
  const [rewriteOriginalWordCount, setRewriteOriginalWordCount] = useState<number>(0);
  const [rewriteErrorWordCount, setRewriteErrorWordCount] = useState<number>(0);
  const [isWordCountModalOpen, setIsWordCountModalOpen] = useState<boolean>(false);
  const [revision, setRevision] = useState('');
  const [comment, setComment] = useState('');
  const [isFirst, setIsFirst] = useState<boolean>(true);
  const hasEduTemSaveData = (comment: any, index: number) => !!comment.eduTemRevisedSentence

  const OVERALL_ASSESSMENT_DEFAULT: string = 'Keep up the good work!';

  /**
   * 에듀템 API로 나온 결과를 Replace하여 태그로 감싸는 작업
   * @param sentence
   */
  const getCorrectText = (sentence: any) => {
    let result: string = '';
    let editorResult: string = '';
    let lastIndex = 0;

    for (let match of sentence?.matches) {
      let offset = match.offset;
      let replacement = match.replacements?.at(0).value;
      if (!replacement) continue;

      let length = match.length;



      // 변경되지 않은 부분을 결과에 추가
      result += sentence.text.substring(lastIndex, offset).replace("    ", "&nbsp;&nbsp;&nbsp;&nbsp;");
      // 변경된 부분을 <span className="edt-a"> 태그로 감싸서 추가
      result += `<span class="edt-b">${sentence.text.substring(offset, offset + length)}</span>`;
      // 기존 단어를 <span className="edt-b"> 태그로 감싸서 추가
      result += `<span class="edt-a">${replacement}</span>`;


      // 변경되지 않은 부분을 결과에 추가
      editorResult += sentence.text.substring(lastIndex, offset).replace("    ", "&nbsp;&nbsp;&nbsp;&nbsp;");
      // 변경된 부분을 Tinymce 에디터에 맞게 태그로 감싸서 추가
      editorResult += `<span style="color: #e03e2d;"><del><strong>${sentence.text.substring(offset, offset + length)}</strong></del></span>`;
      // 기존 단어를 Tinymce 에디터에 맞게 태그로 감싸서 추가
      editorResult += `<span style="color: #236fa1; background-color: #c2e0f4"><strong>${replacement}</strong></span>`;

      lastIndex = offset + length;
    }

    // 남은 부분을 결과에 추가
    result += sentence.text.substring(lastIndex);
    editorResult += sentence.text.substring(lastIndex);

    return { editorText: editorResult, __html: result };
  };

  useEffect(() => {
    document.body.style.backgroundColor = 'white';
    const navbar = document.querySelector('nav.main-header');
    if (navbar) navbar.classList.add('d-none');
    const sidebar = document.querySelector('div.main-sidebar');
    if (sidebar) sidebar.classList.add('d-none');

    document.addEventListener('play', onPlay, true);
    const langCode = i18n.language === 'ko' ? 'kr' : 'en';

    execute(getEvaluationItems(langCode, rubricNo));
    execute2(
      activityType === 'FS'
        ? getStudentFiles(resultCode, activityType)
        : getStudentFile(resultCode, activityType)
    );
    execute3(getWritingEvaluationItems(langCode, rubricNo));
    execute4(getStudentWriting(resultCode));
    execute5(getSavedFeedback(resultCode));

    return () => document.removeEventListener('play', onPlay, true);
  }, []);

  useEffect(() => {
    if (res) {
      const newData: any = [];

      res.data?.evaluationList?.forEach(item => {
        item.evaluationItem.forEach((subitem: any) => {
          subitem.parentItemName = item.parentEvaluationItemName?.trim();
          newData.push(subitem);
        });
      });

      setSpeakingData(_.sortBy(newData, 'evaluationNo'));
    }
  }, [res]);

  useEffect(() => {
    if (res3) {
      const newData: any = [];

      res3.data?.evaluationWritingList?.forEach((item: any) => {
        if (item.treeLevel < 5) {
          item.parentItemName = item.parentEvaluationItemName?.trim();
        } else {
          item.parentItemName = item.grandfatherEvaluationItemName?.trim();
        }          
        newData.push(item);
      });

      setWritingData(_.sortBy(newData, 'evaluationNo'));
    }
  }, [res3]);

  useEffect(() => {
    if (res5?.data && speakingData.length) {
      const newAnswers: any[] = [];
      res5.data.evaluations?.filter(item => item.itemCourseType === 'SP').forEach(item => {
        newAnswers.push(`${item.evaluationNo}-${item.scaleCode}`);
      });

      if (speakingData.length > newAnswers.length) {
        const index = speakingData.findIndex((item: any) => item.bonusYn === 'Y');
        const evaluationNo = speakingData.find((item: any) => item.bonusYn === 'Y')?.evaluationNo;
        if (index) {
          newAnswers.splice(index, 0, `${evaluationNo}-n`);
        }
      }

      setSpeakingAnswers(newAnswers);

      if (res5.data?.teacherComment) {
        setComment(res5.data.teacherComment);
      }
    }
  }, [res5, speakingData]);

  useEffect(() => {
    const { originalWordCount, errorWordCount, rewriteErrorWordCount, rewriteOriginalWordCount } = getCorrectionCountResponse || {};
    setOriginalWordCount(originalWordCount || 0);
    setErrorWordCount(errorWordCount || 0);
    setRewriteErrorWordCount(rewriteErrorWordCount || 0);
    setRewriteOriginalWordCount(rewriteOriginalWordCount || 0);
  }, [getCorrectionCountResponse]);

  useEffect(() => {
    if (res5?.data && writingData.length) {
      const newAnswers: any[] = [];
      res5.data.evaluations?.filter(item => item.itemCourseType === 'WT').forEach(item => {
        newAnswers.push(`${item.evaluationNo}-${item.scaleCode}`);
      });

      if (writingData.length > newAnswers.length) {
        const index = writingData.findIndex((item: any) => item.bonusYn === 'Y');
        const evaluationNo = writingData.find((item: any) => item.bonusYn === 'Y')?.evaluationNo;
        if (index) {
          newAnswers.splice(index, 0, `${evaluationNo}-n`);
        }
      }

      setWritingAnswers(newAnswers);
    }
  }, [res5, writingData]);

  useEffect(() => {
    if (!res4?.data) return;
    /**
     * 미리 저장 된 에듀템 전문이 있을경우 다시 AI를 돌리지 않는다.
     */

    if (isReviewedLoading) return;

    if (getReviewedResponse) {
      setSentencesAll(getReviewedResponse.reviewedContent.split("\n"));
      return;
    }

    setSentencesAll(res4?.data?.studentAnswer?.map((item: any) => item.userAnswer));

    if (proofreadAllData) return;

    if (isReadOnly) return;

    onProofreadAll();
  }, [res4, step, isReviewedLoading, getReviewedResponse]);

  useEffect(() => {
    if (proofreadAllData) {

      console.log("proofreadAllData", proofreadAllData);

      let _map = proofreadAllData?.map((sentence: any) => {
        const { __html } = getCorrectText(sentence);
        return __html;
      });
      setSentencesAll(_map);

      const _data = proofreadAllData;

      let _originalWordCount = res4?.data?.studentAnswer?.map((item: any) => item.userAnswer)?.reduce((acc: number, cur: any) => {
        const wordCount = cur.split(' ').filter((text:string) => text).length;
        return acc + wordCount;
      }, 0);

      let _errorWordCount = _data.reduce((acc: number, cur: any) => {
        const wordCount = cur.matches.length;
        return acc + wordCount;
      }, 0);


      setRewriteOriginalWordCount(_originalWordCount);
      setRewriteErrorWordCount(_errorWordCount);
    }
  }, [proofreadAllData]);

  useEffect(() => {
    if (submitRes) {
      successNotification(t('common.message.save1'));
    }
  }, [submitRes]);

  useEffect(() => {
    if (submitRes2) {
      alert(t('class.tutor.message1'));
      window.opener.postMessage('success', '*');
      window.close();
    }
  }, [submitRes2]);

  useEffect(() => {
    if (!getAdvisorSaveTexts) return;

    if (getAdvisorSaveTexts.length === 0) return;

    if (!getAdvisorSaveTexts.every(hasEduTemSaveData)) return;

    setIsFirst(false);
  }, [getAdvisorSaveTexts]);

  useEffect(() => {
    document.addEventListener('play', onPlay, true);
    return () => document.removeEventListener('play', onPlay, true);
  }, []);

  const onPlay = (e: any) => {
    const audios = document.getElementsByTagName('audio');
    for (let i = 0; i < audios.length; i++) {
      if (audios[i] !== e.target){
        audios[i].pause();
      }
    }
  }

  const onSetSpeakingAnswer = (
    { target: { value } }: RadioChangeEvent,
    index: number,
  ) => {
    const newAnswers = [...speakingAnswers];
    newAnswers[index] = value;
    setSpeakingAnswers(newAnswers);
  };

  const onSetWritingAnswer = (
    { target: { value } }: RadioChangeEvent,
    index: number,
  ) => {
    const newAnswers = [...writingAnswers];
    newAnswers[index] = value;
    setWritingAnswers(newAnswers);
  };

  const onCheckSpeakingAnswers = () => {
    for (let i = 0; i < speakingData.length; i++) {
      if (speakingData[i].bonusYn === 'N') {
        let isIncluded = false;
        for (let j = 0; j < speakingAnswers.length; j++) {
          if (speakingAnswers[j] && speakingAnswers[j].includes(`${speakingData[i].evaluationNo}-`)) {
            isIncluded = true;
          }
        }
        if (!isIncluded) {
          return false;
        }
      }
    }

    return true;
  };

  const onCheckWritingAnswers = () => {
    for (let i = 0; i < writingData.length; i++) {
      if (writingData[i].bonusYn === 'N') {
        let isIncluded = false;
        for (let j = 0; j < writingAnswers.length; j++) {
          if (writingAnswers[j] && writingAnswers[j].includes(`${writingData[i].evaluationNo}-`)) {
            isIncluded = true;
          }
        }
        if (!isIncluded) {
          return false;
        }
      }
    }

    return true;
  };

  const onProofreadAll = () => {
    if (!res4?.data) return;

    const original = res4?.data?.studentAnswer?.map((item: any) => item.userAnswer);
    if (proofreadAllData) {
      proofreadAll(proofreadAllData?.map((sentence: any) => {
        const text = sentence.text;
        return { text }
      }))
      return;
    }

    if (!original || (original && original.length === 0)) return;

    proofreadAll(original?.map((sentence: string) => {
      return { text: sentence?.replace(/(<[^>]*>|&nbsp;)?/g, '') }
    }));
  }

  const renderStudentWriting = () => {
    return (
      _sentencesAll?.map((sentence: any, index: number) => (
        <div key={index} className="bx" dangerouslySetInnerHTML={{__html: sentence}} />
      ))
    );
  }

  const onNext = () => {
    const result = onCheckWritingAnswers();
    if (!result) {
      return infoNotification(t('class.tutor.message2'));
    }

    setIsWordCountModalOpen(true);
  };

  const onSubmit = (completeStatus: string) => {
    if (isReadOnly) {
      setStep(step + 1);
      return;
    }
    setConfirmSubmitVisible(false);

    if (completeStatus === COMPLETE_TYPE.COMPLETED) {
      const result = onCheckSpeakingAnswers();
      if (!result) return infoNotification(t('class.tutor.message2'));
    }


    let req: any = {
      resultCode,
      completeStatus,
      learningTlStructureNo,
      seq,
      activityName: 'Rewrite',
      activityCode,
      speakingEvaluationReq: [],
      writingEvaluationReq: [],
    };

    speakingAnswers.forEach(item => {
      const split = item?.split('-');
      // split[1] = 'n' 이면 선택하지 않은 항목이므로 제외
      if (split && split[1] !== 'n') {
        req.speakingEvaluationReq.push({
          evaluationNo: Number(split[0]),
          scaleCode: split[1],
        });
      }
    });

    writingAnswers.forEach(item => {
      const split = item?.split('-');
      // split[1] = 'n' 이면 선택하지 않은 항목이므로 제외
      if (split && split[1] !== 'n') {
        req.writingEvaluationReq.push({
          evaluationNo: Number(split[0]),
          scaleCode: split[1],
        });
      }
    });

    /**
     * overall comment
     */
    req.teacherComment = comment ? comment : OVERALL_ASSESSMENT_DEFAULT;

    if (_sentencesAll) {
      req.reviewed = {
        quizResultCode: res4?.data?.quizResultCode,
        reviewedType: 'EDU_TEM',
        reviewedContent: _sentencesAll.join('\n'),
      }
    }

    req = {...req, originalWordCount, errorWordCount, rewriteOriginalWordCount, rewriteErrorWordCount}

    completeStatus === COMPLETE_TYPE.STAND_BY
      ? submitExecute(postWritingSpeakingFeedback(rubricNo, req))
      : submitExecute2(postWritingSpeakingFeedback(rubricNo, req))

    if (step === 1) {
      setStep(step + 1);
    }
}

  return (
    <>
      <Helmet>
        <title>Assessment</title>
      </Helmet>
      <div className="box">
        <div className="writing-box-wrap">
          <div className="flex mb-5">
            <div className="header-box">Assessment</div>
            <div className="header-box box-2">
              {displayName}
              <br/>
              {activityName}
            </div>
            <div className="header-box">{feedbackTypeCode === FEEDBACK_TYPE.SPEECH_TEACHER ? 'Speaking' : 'Writing'} {curriculumName}</div>
          </div>
          <div className="col-desc">
            <dl>
              <dt>Name :</dt>
              <dd>{studentKorName} ({studentEngName})</dd>
            </dl>
            <dl>
              <dt>Submitted on :</dt>
              <dd>{moment(regDate).format('YYYY-MM-DD')}</dd>
            </dl>
          </div>
          {/* 실제 컨텐츠 영역 */}
          <div className="row flex-nowrap position-relative">
            <div className="col-6 pr-3">
              <div className="writing-frame position-relative">
                { isReviewedLoading || isProofreadAllLoading || isProofreadAllFetching ? <Loader /> : null }
                {
                  step === 2
                    ? activityType === 'FS'
                      ? res2?.data?.map((item: any, index: number) => (
                        <div
                          key={index}
                          className="flex mb-2"
                        >
                          <audio
                            controls
                            src={item.file?.fileLocation}
                          />
                          <Button
                            className="btn btn-info mt-3 ml-2"
                            onClick={() => {
                              setRecogSentence(item.recogSentence);
                              setShowSttVisible(true);
                            }}
                            text="STT"
                          />
                        </div>
                      ))
                      : (
                        <ReactPlayer
                          url={res2?.data?.file?.fileLocation}
                          width="100%"
                          height="auto"
                          controls
                        />
                      )
                    : (
                      <>
                        <div className="text-right">
                          <button
                            type="button"
                            className="btn btn-primary mb-3"
                            onClick={onProofreadAll}
                            disabled={isReadOnly}
                          >
                            <i className="ic">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                              >
                                <path fill="none" d="M0 0h19.1v19.1H0V0z" />
                                <path
                                  fillRule="evenodd"
                                  fill="#FFF"
                                  d="M17.848 17.852a.501.501 0 0 1-.707 0l-2.198-2.198a3.977 3.977 0 0 1-2.45.844 4.005 4.005 0 0 1-4.001-3.999 4.006 4.006 0 0 1 4.001-4.001 4.005 4.005 0 0 1 4.001 4.001 3.97 3.97 0 0 1-.844 2.448l2.198 2.198a.499.499 0 0 1 0 .707zm-5.355-8.354c-1.655 0-3 1.346-3 3.001a3.003 3.003 0 0 0 3 2.999 3.005 3.005 0 0 0 3.002-2.999 3.005 3.005 0 0 0-3.002-3.001zm0 1.501a1.5 1.5 0 0 0-1.499 1.5.5.5 0 0 1-1.001 0c0-1.379 1.122-2.5 2.5-2.5a.5.5 0 1 1 0 1zM4.957 5.261a.664.664 0 0 1 1.204 0l1.321 2.838a.463.463 0 0 1-.421.659h-.006a.462.462 0 0 1-.427-.28l-.197-.458H4.677l-.193.457a.465.465 0 1 1-.849-.378l1.322-2.838zm1.148 1.951-.541-1.283h-.022l-.535 1.283h1.098zm-2.013 6.907h2.2a.5.5 0 0 1 0 1h-2.2a.5.5 0 1 1 0-1zm0-3.18h2.7a.5.5 0 1 1 0 1h-2.7a.5.5 0 1 1 0-1zM8.63 4.877c.283 0 .514.231.514.515v2.852a.514.514 0 1 1-1.03 0V5.392c0-.284.231-.515.516-.515zm4.912 2.822a.357.357 0 0 1-.357-.357V5.026h-1.871a.386.386 0 0 1-.385-.385v-1.87H2.763v14.455h6.975c.196 0 .355.16.355.357v.046a.356.356 0 0 1-.355.355l-7.331.015a.394.394 0 0 1-.386-.387l-.03-15.228c0-.208.179-.386.387-.386h8.906c.089 0 .179.03.238.09.03.029 2.287 2.255 2.287 2.286.058.059.088.118.088.177v2.791c0 .197-.16.357-.355.357zM11.67 3.275v.95h.95l-.95-.95z"
                                />
                              </svg>
                            </i>
                            AI Proofreading
                          </button>
                        </div>
                        <div className="text-content">
                          {renderStudentWriting()}
                        </div>
                      </>
                    )
                }
              </div>
            </div>
            <div className="col-6">
              {
                step === 1
                  ? (
                    <>
                      {
                        writingData.map((item: any, index: number) => (
                          <EvaluationItem
                            key={index}
                            item={item}
                            index={index}
                            answers={writingAnswers}
                            onSetAnswer={onSetWritingAnswer}
                            isReadOnly={isReadOnly}
                          />
                        ))
                      }
                      <div className="mb-4">
                        <div className="tox-editor-item">
                          <CommentEditor
                            comment={comment}
                            setComment={setComment}
                            feedbackTypeCode={feedbackTypeCode}
                            revision={revision}
                            setRevision={setRevision}
                            isRewrite={true}
                          />
                        </div>
                      </div>
                    </>
                  )
                : speakingData.map((item: any, index: number) => (
                    <EvaluationItem
                      key={index}
                      item={item}
                      index={index}
                      answers={speakingAnswers}
                      onSetAnswer={onSetSpeakingAnswer}
                      isReadOnly={isReadOnly}
                    />
                  ))
              }
            </div>
          </div>
          <div className="text-right mt-2">
            <Button
              className="btn btn-secondary btn-w100p ml-1"
              onClick={window.close}
              text={t('common.button.close')}
            />
            {step === 1
              ? (
                <Button
                  className="btn btn-info btn-w100p ml-1"
                  onClick={onNext}
                  text={t('common.button.next')}
                />
              )
              : (
                <>
                  <Button
                    className="btn btn-info btn-w100p ml-1"
                    onClick={() => setStep(step - 1)}
                    text={t('common.button.back')}
                  />
                  <Button
                    className="btn btn-info btn-w100p ml-1"
                    onClick={() => onSubmit(COMPLETE_TYPE.STAND_BY)}
                    text={t('common.button.save')}
                    disabled={isReadOnly}
                  />
                  <Button
                    className="btn btn-primary btn-w100p ml-1"
                    onClick={() => setConfirmSubmitVisible(true)}
                    text={t('class.tutor.button5')}
                    disabled={isReadOnly}
                  />
                </>
              )
            }
          </div>
        </div>
      </div>
      {confirmSubmitVisible &&
        <ConfirmModal
          visible={confirmSubmitVisible}
          setVisible={setConfirmSubmitVisible}
          onConfirm={() => onSubmit(COMPLETE_TYPE.COMPLETED)}
          titleText={t('class.tutor.button5')}
          messageText={t('class.tutor.text3')}
          confirmText={t('common.option.yes')}
          cancelText={t('common.option.no')}
        />
      }
      {
        isWordCountModalOpen && <OverallWordCheckModal
          isOpen={isWordCountModalOpen}
          setIsOpen={setIsWordCountModalOpen}
          onReportSaveSubmit={onSubmit}
          submitType={COMPLETE_TYPE.STAND_BY}
          activityName={activityName}
          displayName={displayName}
          isReadOnly={isReadOnly}
          originalWordCount={originalWordCount}
          errorWordCount={errorWordCount}
          setOriginalWordCount={setOriginalWordCount}
          setErrorWordCount={setErrorWordCount}
          rewriteOriginalWordCount={rewriteOriginalWordCount}
          rewriteErrorWordCount={rewriteErrorWordCount}
          setRewriteOriginalWordCount={setRewriteOriginalWordCount}
          setRewriteErrorWordCount={setRewriteErrorWordCount}
          isOkText={isReadOnly ? t('common.button.confirm') : t('common.button.save')}
        />
      }
    </>
  );
}

export default TutorAssessWs;